import React from "react";
import { motion } from "framer-motion";
import Profile from "../../../../assets/images/profile.png";
import {
  zoomVariants,
  fadeDelayVariants
} from "../../../../components/shared/utils/animations";

const LeadPlayer = (props) => {
  const {
    guessedWords,
    skippedWords,
    team,
    quaterBack,
    lastTeam,
    buzzledWords
  } = props;
  return (
    <div
      className={`players-scores-wrapper ${
        lastTeam === true ? "second-player" : "first-player"
      }`}
    >
      <motion.div
        variants={fadeDelayVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        className="players-details"
      >
        <img
          src={quaterBack ? quaterBack.profile_image : ""}
          className="profile-img"
        />
        <div>
          <h2 className="text">{quaterBack ? quaterBack.display_name : ""}</h2>
          <p className="text-orange mb-0">{team}</p>
        </div>
      </motion.div>
      <motion.div
        variants={zoomVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        className="players-number bg-d-card text"
      >
        <div>
          <div className="numbers">
            <p className="digits text-lightGreen">
              {guessedWords.length}
              {/* <span className="number-text">Guessed</span> */}
            </p>
            <p className="digits ">
              <span className="text-yellow minus">-</span>
              <span className="text-yellow">
                {skippedWords.length + buzzledWords.length}
              </span>
              {/* <span className="number-text">
                <span className="text-darkPink">Buzzed</span>
                <span className="text-white"> / </span>
                <span className="text-orange">Skipped</span>
              </span> */}
            </p>
          </div>
          <p
            className={`total ${
              guessedWords.length -
                (skippedWords.length + buzzledWords.length) <
              0
                ? // ? "text-darkRed"
                  ""
                : ""
            }`}
          >
            {guessedWords.length - (skippedWords.length + buzzledWords.length) <
            0
              ? 0
              : guessedWords.length -
                (skippedWords.length + buzzledWords.length)}
            {/* <span className="number-text round-score">
              <span className="score-text">Round Score</span>
              {guessedWords.length -
                (skippedWords.length + buzzledWords.length) <
              0 ? (
                <span className="text-darkPink negative">(negative)</span>
              ) : null}
            </span> */}
          </p>
        </div>
      </motion.div>
    </div>
  );
};
export default LeadPlayer;
